import React from 'react';
import NavBar from '../components/Home/NavBar';
import doctoraIMG from "../assets/doctora.png"

const About = () => {
  return (
  <div className='bg-bgSteps h-full sm:h-screen '>
      <NavBar />

  <div className='flex h-full bg-bgSteps items-center justify-center sm:mt-12 sm:ml-8'>
     
     <div className='w-1/4 hidden sm:flex justify-end '>
      <img alt='hola' src={doctoraIMG} className='w-64 h-64 '/>
     </div>
     
     <div className='flex justify-start items-center w-11/12 sm:w-3/4 font-roboto ml-20'>
     <div className="bg-white rounded-lg shadow-lg max-w-3xl px-12 py-10 mt-8" style={{width:""}}>
             <h1 className="text-[20px]  sm:text-3xl font-bold mb-4">Qué es el REPROCANN?</h1>
             <p className="text-sm sm:text-lg text-gray-700 mb-4">El Reprocann es una base de datos diseñada para poder registrar a aquellas personas que cuenten con las condiciones para acceder a un cultivo controlado de la planta de cannabis, con fines de tratamiento medicinal, terapéutico y/o paliativo del dolor.
</p>
             <p className="text-sm sm:text-lg text-gray-700 mb-4">
El Reprocann, una vez aprobado por el ministerio de salud, autoriza al paciente a poder cultivar entre 1 y 9 plantas florecidas, en hasta 6mts cuadrados en interior o 15mts cuadrados en exterior  dentro de la propiedad privada❗ y autoriza poder transportar entre 1 y 6 frascos de 30 mililitros o hasta 40 gramos de flores secas!</p>
               <h1 className="text-[20px]  sm:text-3xl font-bold mb-4">Quiénes somos?
</h1>
             <p className="text-sm sm:text-lg text-gray-700 mb-4">Somos una asesoría médica dedicada a personas que optan y/o necesitan un tratamiento médico con cannabis.
Desde la evaluación inicial hasta el esquema terapéutico personalizado, nos comprometemos a proporcionar un acompañamiento excepcional desde el primer contacto con el paciente.
</p>
             <p className="text-sm sm:text-lg text-gray-700 mb-4">En Dra. M. Weed, nos enorgullece brindar una atención médica de calidad en un ambiente seguro, confidencial y respetuoso. Nuestra prioridad es siempre la salud y el bienestar de nuestros pacientes, y estamos comprometidos a proporcionar un servicio excepcional en todo momento. A demás de la consulta médica personalizada para cada uno, el paciente tiene el whatsapp a su disposición para resolver cualquier duda, y así garantizar que reciban el cuidado que necesitan y merecen! 
</p>
             <p className="text-sm sm:text-lg text-gray-700 mb-4">Creemos y contamos con miles de historias en las que la terapia con cannabis ha dado maravillosos resultados, a demas de su seguridad y eficacia, es un tratamiento natural y muy amable con nuestro organismo.
Si estás buscando obtener autorización para hacer uso, realizar un cultivo controlado y personalizado, contactate con nosotras! 
</p>
        </div>

     </div>

  </div>



 </div>
  )
}

export default About;
